import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LabRequestForm from './pages/LabRequestForm';
import Confirmacion from './pages/Confirmacion';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LabRequestForm />} />
          <Route path="/confirmacion" element={<Confirmacion />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;